import { render } from "./CpsDetailWysiwyg.vue?vue&type=template&id=26aae60d&scoped=true&ts=true"
import script from "./CpsDetailWysiwyg.vue?vue&type=script&lang=ts"
export * from "./CpsDetailWysiwyg.vue?vue&type=script&lang=ts"

import "./CpsDetailWysiwyg.vue?vue&type=style&index=0&id=26aae60d&lang=css"
import "./CpsDetailWysiwyg.vue?vue&type=style&index=1&id=26aae60d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26aae60d"]])

export default __exports__